import { render, staticRenderFns } from "./vueTxt.vue?vue&type=template&id=0b505038&scoped=true"
import script from "./vueTxt.vue?vue&type=script&lang=js"
export * from "./vueTxt.vue?vue&type=script&lang=js"
import style0 from "./vueTxt.vue?vue&type=style&index=0&id=0b505038&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b505038",
  null
  
)

export default component.exports